export class SmartSearchModel {
	keyword: string = "";
	isVisible: boolean = null;
	refId: number = null;
	pageNum: number = 1;
	pageSize: number = 10;
}
